import { ANIMATIONS } from '../app.config';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';
import { MorphSVGPlugin } from '@gsap/business/MorphSVGPlugin';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MorphSVGPlugin)

export default class Morph {

  constructor(context) {
    this.context = context;
    ANIMATIONS && this.init();
  }

  initAnimations() {
    this.items.forEach(el => {
      switch (el.type) {
        case 'patch':
          this.patchAnimation(el.items)
          break;
      }
    })
  }

  patchAnimation(items) {
    this.mouseOverHandler = this.onMouseOver.bind();
    this.mouseOutHandler = this.ouMouseOut.bind();

    items.forEach(item => {
      item.addEventListener('mouseenter',  this.mouseOverHandler)
      item.addEventListener('mouseleave',  this.mouseOutHandler)
    })
  }

  onMouseOver(e) {
    const button = e.currentTarget;
    const startPoint = button.querySelector('.card__shape-1');
    const endPoint = button.querySelector('.card__shape-2');
    gsap.to(startPoint, { morphSVG: endPoint, ease: "expo.out", duration: 1, });
  }

  ouMouseOut(e) {
    const button = e.currentTarget;
    const startPoint = button.querySelector('.card__shape-1');
    gsap.to(startPoint, { morphSVG: startPoint, ease: "expo.out", duration: 1 });
  }


  init() {
    const elements = Array.from(this.context.querySelectorAll('[data-animate-morph]'));
    const patchAnimation = elements.filter(x => x.dataset.animateMorph === 'patch');
    this.items = [{
      type: 'patch',
      items: patchAnimation ? patchAnimation : []
    }]
    this.initAnimations();
  }
}
